import GeoService from "../services/GeoService";
import Select from "./base/Select";


function CountrySelect({
  name, value, onChange, onBlur,border,borderRadius,backgroundColor
}) {
  return (
    <Select
      value={value}
      name={name}
      options={GeoService.getCountries().map((country) => ({
        name: country.name,
        value: country.code,
      }))}
      onBlur={onBlur}
      onChange={onChange}
      border={border}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
    />
  );
}

export default CountrySelect;
